import { useState, useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * Rotating motivational phrases shown while the simulation is being analysed.
 * Helps the user understand that the AI is working and the wait is expected.
 */
const LoadingPhrases = () => {
  const { t } = useLanguage();
  const keys = [
    "consulta_loading_phrase_1",
    "consulta_loading_phrase_2",
    "consulta_loading_phrase_3",
    "consulta_loading_phrase_4",
    "consulta_loading_phrase_5",
  ];
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % keys.length);
    }, 3500);
    return () => clearInterval(id);
  }, [keys.length]);

  return (
    <p
      key={idx}
      className="text-white/55 text-xs sm:text-sm text-center max-w-xs animate-fade-in"
      data-testid="consulta-loading-phrase"
    >
      {t(keys[idx])}
    </p>
  );
};

export default LoadingPhrases;
